
import { useCallback } from 'react';
import { FeatureService } from '@/lib/services/feature-service';
import { useAuth } from '@/hooks/use-auth';
import { useToast } from '@/components/ui/use-toast';

export function useFeatureTracking() {
  const { user } = useAuth();
  const { toast } = useToast();

  const trackFeatureUsage = useCallback(async (featureName: string) => {
    if (!user) {
      console.log('Feature tracking skipped: No user logged in');
      return;
    }
    
    try {
      await FeatureService.trackFeatureUsage(featureName, user.id);
    } catch (error) {
      console.error('Error tracking feature usage:', error);
      // Don't show error toast to users as this is not critical functionality
    }
  }, [user]);

  return {
    trackFeatureUsage
  };
}
